import { currency } from "../services/common.service";
import { InputContainer } from "./form/form.module";
import { InputLabelContainer } from "./form/label/containers/input-label.container";


export const PaymentStatusActionComponent = ({
    value,
    onPaymentFormChange,
    dataId,
    paymentValues,
    paymentLibrary
}: any) => {

    return (


        <>
            {(dataId?.PaymentMethodId === 10 && value !== 30) ? (
                <>
                    <div className=" grid md:grid-cols-2 lg:grid-cols-2 gap-2">
                        <div>
                            <InputLabelContainer
                                label="Order Total"
                            />
                            {currency(dataId?.message?.MarketPlaceOrderTotal || dataId?.OrderTotal)}
                        </div>

                        <div></div>
                        <InputContainer
                            label="Payment Status"
                            labelField="Text"
                            list={paymentLibrary}
                            onValueChange={(event: any) => {
                                onPaymentFormChange({
                                    fieldValue: event.target.value,
                                    field: 'PaymentStatusId'
                                });
                            }}
                            type="select"
                            optionName="Choose PaymentStatus"
                            value={paymentValues?.PaymentStatusId || value}
                            valueField="Value"
                        />
                        <InputContainer
                            label="Paid Amount"
                            name="PaidAmount"
                            onValueChange={(event: any, _newValue: any) => {
                                onPaymentFormChange({
                                    fieldValue: event.target.value,
                                    field: 'PaidAmount'
                                });
                            }}
                            type="number"
                            value={paymentValues?.PaidAmount}
                        />
                    </div>
                </>
            ) : <>
                <div className=" grid md:grid-cols-2 lg:grid-cols-2 gap-2">
                    <div>
                        <InputLabelContainer
                            label="Order Total"
                        />
                        {currency(dataId?.message?.MarketPlaceOrderTotal || dataId?.OrderTotal)}
                    </div>
                    <div></div>
                    <InputContainer
                        isDisabled
                        label="Payment Status"
                        labelField="Text"
                        list={paymentLibrary}
                        onValueChange={(event: any) => {
                            onPaymentFormChange({
                                fieldValue: event.target.value,
                                field: 'PaymentStatusId'
                            });
                        }}
                        type="select"
                        value={paymentValues?.PaymentStatusId || value}
                        valueField="Value"
                    />
                    <InputContainer
                        isDisabled
                        label="Paid Amount"
                        name="PaidAmount"
                        onValueChange={(event: any, _newValue: any) => {
                            onPaymentFormChange({
                                fieldValue: event.target.value,
                                field: 'PaidAmount'
                            });
                        }}
                        type="number"
                        value={dataId?.message?.MarketPlaceOrderTotal || dataId?.OrderTotal}
                    />
                </div>
            </>
            }
        </>



    );
};
